<!-- Template -->

<template>
    <div>
        
        <a class="btn-large btn-transparent request-support-button" @click.prevent="openDialog()">Request Support </a>
        
        <TicketSystemDialog
            ref="ticketSystemDialog"
            @select="newTicketDialog.show($event)"
            @viewOpenedTickets="ticketListDialog.show($event)"
        />

        <TicketDetailsDialog
            ref="ticketDetailsDialog"
            @back="ticketSystemDialog.show()"
            :showBack="true"
        />

        <TicketList
            ref="ticketListDialog"
            @close="ticketSystemDialog.show()"
            @showTicketDetails="ticketDetailsDialog.show($event)"
        />

        <TicketDetailsReadOnly
            ref="ticketDetailsReadOnly"
            @close="ticketListDialog.show($event)"
            :showBack="true"
        />

        <NoActiveContractsSupportDialog ref="noActiveContractsDialog" />
    </div>
</template>

<!-- Script -->

<script>
    import TicketSystemDialog from "@/components/Dialogs/TicketSystem";
    import TicketDetailsDialog from "@/components/Dialogs/TicketDetails";
    import TicketList from "@/components/Dialogs/TicketList";
    import TicketDetailsReadOnly from "@/components/Dialogs/TicketDetailsReadOnly";
    import NoActiveContractsSupportDialog from "@/components/Dialogs/NoActiveContractsSupportDialog";
    export default {
        name: "RequestSupportButton",

        components: {
            TicketSystemDialog,
            TicketDetailsDialog,
            TicketList,
            TicketDetailsReadOnly,
            NoActiveContractsSupportDialog
        },

        data(){
            return{
                canRaiseTicket: false
            }
        },

        watch: { 
            '$route.params.hospital': {
                handler: function(hospital) {
                    this.update(hospital);
                },
                deep: true,
                immediate: true
            }
        },

        computed: {
             ticketSystemDialog() {
                return this.$refs.ticketSystemDialog;
            },
            newTicketDialog() {
                return this.$refs.ticketDetailsDialog;
            },
            ticketListDialog() {
                return this.$refs.ticketListDialog;
            },
            ticketDetailsDialog() {
                return this.$refs.ticketDetailsReadOnly;
            },
            noActiveContractsDialog() {
                return this.$refs.noActiveContractsDialog;
            }
        },

        methods:{
            openDialog(){
                if(this.canRaiseTicket){
                    //this.noActiveContractsDialog.close();
                    this.ticketSystemDialog.show();
                }else{
                    //this.ticketSystemDialog.close();
                    this.noActiveContractsDialog.show();
                }
            },

            update(hospital){
                var sites = this.$store.getters['hospital/sites'];
                var selectedSite = sites.filter(function(el) {
                    return el.id == hospital;
                });
                this.canRaiseTicket = selectedSite[0].canRaiseTicket;
            }
        }
    };
</script>

